import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import InputField from "../../component/InputField";
import ButtonCompo from "../../component/ButtonCompo";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import AlertBox from "../../component/AlertBox";

function OnboardedEmployees() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [employees, setEmployees] = useState([]);
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.onBoardingAccess === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  //fetch all onboarded employee
  async function getOnboardedEmployees() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/employee/onboarded/get`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setEmployees(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Onboarded employees fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getOnboardedEmployees();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Onboarded Employees Pipeline
          </h1>
          <div className="mt-5 w-full">
            <div className="w-full flex justify-end gap-3">
              <TextField label="Search" size="small" />
              <ButtonCompo variant={"contained"}>Search</ButtonCompo>
            </div>
            <div className="w-full mt-5">
              <Table>
                <TableHead>
                  <TableRow className="bg-blue-500">
                    <TableCell className="!text-center !text-white !font-semibold">
                      SL No
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Employee ID
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Date of Onboarding
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Name
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Email
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Phone Number
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Role
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Designation
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      CTC
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Edit
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="border">
                  {employees?.map((e, i) => (
                    <TableRow>
                      <TableCell className="!text-center !font-medium">
                        {i + 1}
                      </TableCell>
                      <TableCell className="!text-center !font-medium !text-blue-600">
                        <span className="bg-blue-200/40 px-3 py-2 rounded-full font-medium text-[13px]">
                          {e?.employeeId}
                        </span>
                      </TableCell>
                      <TableCell className="!text-center">
                        {new Date(e?.onBoardingDate).toLocaleDateString()}
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.fullName}
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.profEmail}
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.phoneNumber}
                      </TableCell>
                      <TableCell className="!text-center">{e?.role}</TableCell>
                      <TableCell className="!text-center">
                        {e?.designation}
                      </TableCell>
                      <TableCell className="!text-center">
                        <span className="bg-green-200/40 text-green-700 px-3 py-2 rounded-full font-medium text-[13px]">
                          ₹{e?.ctc}
                        </span>
                      </TableCell>
                      <TableCell className="!text-center">
                        <ButtonCompo
                          href={`/admin/onboarded-employees/edit/${e?._id}`}
                        >
                          Edit
                        </ButtonCompo>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OnboardedEmployees;
